import React from 'react';
import { ModalComponent, Toaster } from '@hugendubel/react-basic';
import { Authorize } from './auth/Authorize';

export const App: React.FC = () => (
    <>
        <div className="page-container">
            <Authorize />
        </div>
        <ModalComponent />
        <Toaster.Component />
    </>
);
